import { ReactNode, useContext } from 'react'
import { Transition } from './animations'
import { RouteObject, RouteTransitions } from '../types'
import { OptionsContext } from './contexts'

// function getCanApplyTransition(
//   oldBranch: RouteObject[] | undefined,
//   newBranch: RouteObject[],
// ) {
//   if (!oldBranch)
//     return !newBranch.reduce(
//       (acc, item) => acc || !!item.routeTransitions,
//       false,
//     )
//
//   let pointer = 0
//   const pointerMax = Math.min(oldBranch.length, newBranch.length)
//
//   while (pointer < pointerMax) {
//     if (oldBranch[pointer].name !== newBranch[pointer].name) return true
//     if (newBranch[pointer].routeTransitions) return false
//     pointer++
//   }
//
//   return true
// }

interface RoutesTransitionsProps extends RouteTransitions {
  activeKey: number
  branchRemainedPart: RouteObject[]
  children?: ReactNode
}
export function RoutesTransitions({
  name,
  activeKey,
  // branchRemainedPart,
  children,
  ...transitionProps
}: RoutesTransitionsProps) {
  // const oldBranchRemainedPartRef = useRef<RouteObject[]>()
  // const remainedLocation = branchRemainedPart.map(({ name }) => name).join('/')

  const { disableAnimations } = useContext(OptionsContext)

  // useEffect(() => {
  //   const oldBranchRemainedPart = oldBranchRemainedPartRef.current
  //   const canApplyTransition = getCanApplyTransition(
  //     oldBranchRemainedPart,
  //     branchRemainedPart,
  //   )
  //
  //   if (canApplyTransition && oldBranchRemainedPart)
  //     animateOut((outTransition || transition)!, containerRef.current)
  //   setChildrenToRender(childrenRef.current)
  //
  //   if (canApplyTransition && (applyOnMount || oldBranchRemainedPart))
  //     animateIn((inTransition || transition)!, containerRef.current)
  //
  //   oldBranchRemainedPartRef.current = branchRemainedPart
  // }, [remainedLocation, applyOnMount])

  return (
    <Transition
      activeKey={activeKey}
      name={disableAnimations || !name ? 'none' : name}
      {...transitionProps}
    >
      {children}
    </Transition>
  )
}
